import { render, staticRenderFns } from "./form-aboutme.vue?vue&type=template&id=6c05de2c"
import script from "./form-aboutme.vue?vue&type=script&lang=js"
export * from "./form-aboutme.vue?vue&type=script&lang=js"
import style0 from "./form-aboutme.vue?vue&type=style&index=0&id=6c05de2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports